const photoGalleryData = [
	{
		id: 2014422,
		url: "https://images.pexels.com/photos/2014422/pexels-photo-2014422.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/203312/tobias-kurschner-784.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Joey Farina",
		photographer_id: 680589,
		price: 125,
		liked: false,
		comment_count: 25
	},
	{
		id: 6909935,
		url: "https://images.pexels.com/photos/6909935/pexels-photo-6909935.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/159445/ulrike-hassler-433.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "John Nail",
		photographer_id: 184758,
		price: 325,
		liked: false,
		comment_count: 15
	},
	{
		id: 5031045,
		url: "https://images.pexels.com/photos/5031045/pexels-photo-5031045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/2166283/damian-konietzny-923.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Erick Mclean",
		photographer_id: 946387,
		price: 100,
		liked: false,
		comment_count: 5
	},
	{
		id: 241778,
		url: "https://images.pexels.com/photos/241778/pexels-photo-241778.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/2077421/vinicius-stacciarini-994.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Jihn Sullivan",
		photographer_id: 684836,
		price: 300,
		liked: false,
		comment_count: 9
	},
	{
		id: 241761,
		url: "https://images.pexels.com/photos/241761/pexels-photo-241761.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/201845/nanzz-van-vliet-803.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Matthew Spalding",
		photographer_id: 735578,
		price: 230,
		liked: false,
		comment_count: 42
	},
	{
		id: 8374858,
		url: "https://images.pexels.com/photos/19443/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/3671417/hershe-girl-go-801.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Torcasio Murphy",
		photographer_id: 419634,
		price: 130,
		liked: false,
		comment_count: 19
	},
	{
		id: 92109,
		url: "https://images.pexels.com/photos/92109/pexels-photo-92109.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/3847895/anand-thakur-405.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Roney Chase",
		photographer_id: 836736,
		price: 630,
		liked: false,
		comment_count: 23
	},
	{
		id: 2812808,
		url: "https://images.pexels.com/photos/2812808/pexels-photo-2812808.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/674447/marjolein-hos-484.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Rocha Kalu",
		photographer_id: 983648,
		price: 630,
		liked: false,
		comment_count: 13
	},
	{
		id: 1254305,
		url: "https://images.pexels.com/photos/1254305/pexels-photo-1254305.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/3076346/corey-akers-914.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Staffieri Hanafi",
		photographer_id: 664858,
		price: 300,
		liked: false,
		comment_count: 17
	},
	{
		id: 854900,
		url: "https://images.pexels.com/photos/854900/pexels-photo-854900.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/2751080/eduardo-hideki-akamine-umino-135.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Zetong Li",
		photographer_id: 294748,
		price: 150,
		liked: false,
		comment_count: 34
	},
	{
		id: 1761279,
		url: "https://images.pexels.com/photos/1761279/pexels-photo-1761279.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/159327/danguole-serstinskaja-544.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Jacob Colvin",
		photographer_id: 928564,
		price: 450,
		liked: false,
		comment_count: 31
	},
	{
		id: 1995730,
		url: "https://images.pexels.com/photos/1995730/pexels-photo-1995730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
		profile_url: "https://images.pexels.com/users/avatars/2064216/jared-muller-542.jpeg?auto=compress&fit=crop&h=60&w=60",
		photographer: "Darwis Alwan",
		photographer_id: 683365,
		price: 230,
		liked: false,
		comment_count: 8
	}
]

export default photoGalleryData